import { render, staticRenderFns } from "./AddAcademyUser.vue?vue&type=template&id=f64f93ec&scoped=true"
import script from "./AddAcademyUser.vue?vue&type=script&lang=js"
export * from "./AddAcademyUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64f93ec",
  null
  
)

export default component.exports